export const AddUserIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.7631 3.87134C8.07976 3.87134 5.88426 6.30949 5.88426 9.31363C5.88426 12.3178 8.07976 14.7559 10.7631 14.7559C13.4465 14.7559 15.642 12.3178 15.642 9.31363C15.642 6.30949 13.4465 3.87134 10.7631 3.87134ZM5.66471 14.7559C3.0789 14.8648 1.00537 16.7587 1.00537 19.1098V21.2867H20.5209V19.1098C20.5209 16.7587 18.4718 14.8648 15.8616 14.7559C14.5443 16.0838 12.7391 16.9328 10.7631 16.9328C8.7872 16.9328 6.98201 16.0838 5.66471 14.7559Z"
      fill="#8090A9"
    />
    <path
      d="M19.8704 7.60316V9.46909H17.9188V10.713H19.8704V12.579H21.1714V10.713H23.123V9.46909H21.1714V7.60316H19.8704Z"
      fill="#8090A9"
    />
  </svg>
);
